import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useGlobalStore } from '../../providers/GlobalStoreProvider';
import { ContractorVerificationStatuses, UserRoles } from '../../constants/entities';
import Routes from '../routes.enum';

interface BlockedAgencyGuardProps {
  children: ReactNode;
}

const BlockedAgencyGuard = ({ children }: BlockedAgencyGuardProps) => {
  const { agency, user } = useGlobalStore();
  const location = useLocation();
  const isProfileSetUp =
    user.data?.personalProfileCompleted && user.data?.isAgencySet && user.data?.emailConfirmed;

  if (isProfileSetUp && user.data?.role !== UserRoles.Admin && agency.isError) {
    return <Navigate to={Routes.SignIn} replace />;
  }

  const isAgencyBlocked =
    agency.data?.verificationStatus === ContractorVerificationStatuses.Blocked;
  const isOnBlockedPage = location.pathname === Routes.AgencyBlocked;

  // If agency is blocked and user is not on the blocked page, redirect to blocked page
  if (isAgencyBlocked && !isOnBlockedPage) {
    return <Navigate to={Routes.AgencyBlocked} replace />;
  }

  // If agency is not blocked but user is on blocked page, redirect to dashboard
  if (!isAgencyBlocked && isOnBlockedPage) {
    return <Navigate to={Routes.Dashboard} replace />;
  }

  // Otherwise, render children normally
  return children;
};

export default BlockedAgencyGuard;
